<template>
  <div class="chatRoom">
    <a-card :bordered="false" style="height: 25%; margin-bottom: 10px">
      <!-- 搜索区域-->

      <a-form
        layout="inline"
        @keyup.enter.native="searchQuery"
        class="searchForm"
      >
        <a-row :gutter="24">
          <a-col :span="8">
            <a-form-item label="发送人">
              <a-select
                show-search
                v-model="searchObj.sendUser"
                placeholder="请输入发送人名称"
                style="width: 170px"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="(value) => handleSearch(value, 'sendUser')"
                @change="(value) => handleChange(value, 'sendUser')"
              >
                <a-select-option
                  v-for="(item, index) in userSendData"
                  :key="item.id + '_' + item.name + '_' + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="接收人">
              <a-select
                show-search
                v-model="searchObj.receiveUser"
                placeholder="请输入接收人名称"
                style="width: 170px"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="(value) => handleSearch(value, 'receiveUser')"
                @change="(value) => handleChange(value, 'receiveUser')"
              >
                <a-select-option
                  v-for="(item, index) in userReceiveData"
                  :key="item.id + '_' + index"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="会话日期" style="margin: 0">
              <a-range-picker
                v-model="conversationDate"
                style="width: 60%"
                @change="
                  (data, dateValue) => onDateChange(data, dateValue, '1')
                "
              ></a-range-picker>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" v-if="showMore" style="margin-top: 10px">
          <a-col :span="8">
            <a-form-item label="聊天记录">
              <a-input
                placeholder="请输入聊天记录"
                v-model="searchObj.content"
              ></a-input>
            </a-form-item>
          </a-col>

          <a-col :span="6">
            <!-- <a-form-item label="群成员">
                <a-input placeholder="请输入群成员名称" v-model="searchObj.groupMemberName"></a-input>
              </a-form-item> -->
            <a-form-item label="聊天类型">
              <a-select
                style="width: 155px"
                placeholder="请选择聊天类型"
                v-model="searchObj.type"
              >
                <a-select-option value="0">全部</a-select-option>
                <a-select-option value="1">私聊</a-select-option>
                <a-select-option value="2">群聊</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="10">
            <a-form-item label="群名">
              <a-input
                placeholder="请输入群名"
                v-model="searchObj.roomName"
                style="width: 230px"
              ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
        <!-- <a-row :gutter="24" v-if="showMore" style="margin-top:10px">
            <a-col :span="8">
              <a-form-item label="聊天类型" >
                <a-select style="width: 170px" placeholder="请选择聊天类型" v-model="searchObj.type">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">私聊</a-select-option>
                  <a-select-option value="2">群聊</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row> -->
        <a-row :gutter="24" style="margin-top: 10px">
          <a-col :md="24" :sm="24">
            <a-button
              type="primary"
              style="margin-right: 10px"
              @click="searchQuery"
            >
              查询
            </a-button>
            <a-button @click="messageReset('chatContent')"> 重置 </a-button>
            <div @click="showMoreSearch" class="showMore">
              {{ showMore ? '收起' : '展开' }}&nbsp;<a-icon
                :type="showMore ? 'up' : 'down'"
              />
            </div>
          </a-col>
        </a-row>
      </a-form>
    </a-card>
    <div class="chatContent" style="position: relative">
      <a-card :bordered="false" style="width: 20%; margin-right: 10px">
        <div class="chatLeft">
          <div class="searchtop">
            <span style="font-size: 18px; font-weight: 800">联系人列表</span>
          </div>
          <div style="marginleft: 50%; margintop: 50%" v-if="isSearching">
            <a-spin />
          </div>
          <div
            class="chatListContainer"
            v-if="!isSearching && chatListData.length > 0"
          >
            <div
              v-for="(item, index) in chatListData"
              :key="item.id"
              class="chatListItem"
              @click="onChange(item.id, index)"
              :class="isActive == index ? 'chatListItemActive' : ''"
            >
              <img
                src="../../../assets/chatroom.jpg"
                alt=""
                class="chatRoomImg"
                width="40px"
                height="40px"
                style="margin-top: 6px; border-radius: 50%"
              />
              <span class="chatRoomTitle" v-if="item.roomId">{{
                item.roomName || item.ownerName + '的群'
              }}</span>
              <span class="chatRoomTitle" v-if="!item.roomId">{{
                item.title.replace('null', '未知用户') ||
                item.roomName ||
                item.ownerName + '的群'
              }}</span>
              <span class="chatRoomTitle" v-if="item.lastMsg">{{
                item.lastMsg.content ? item.lastMsg.content : '无内容'
              }}</span>
            </div>
          </div>
          <div
            class="chatListContainer"
            v-if="!isSearching && chatListData.length == 0"
            style="flex: 1"
          >
            <a-empty style="margin: 50% 0 0 0" />
          </div>
        </div>
      </a-card>
      <a-card :bordered="false" style="width: 80%; display: flex">
        <div class="chatRight">
          <div class="chatTitle">
            <span style="font-size: 18px; font-weight: 800">{{ msgfrom }}</span>
          </div>
          <div style="marginleft: 50%; margintop: 30%" v-if="loading">
            <a-spin />
          </div>
          <div
            v-if="!loading"
            class="chatContentList"
            @scroll="upScrollFn"
            id="chatContent"
          >
            <div
              class="chatRoomContent"
              v-if="chatContentData && chatContentData.length > 0"
            >
              <div v-for="(item, index) in chatContentData" :key="index">
                <div
                  class="contentItem"
                  v-if="item.name != searchObj.sendUser"
                  style="width: 70%"
                >
                  <div>
                    <img
                      v-if="item.headUrl"
                      :src="item.headUrl"
                      alt=""
                      class="touxiang"
                    />
                    <img
                      v-else
                      src="../image/user.jpg"
                      alt=""
                      class="touxiang"
                    />
                  </div>
                  <div class="content">
                    <b
                      >{{ item.name }}
                      <i style="font-size: 12px; font-style: normal">{{
                        timestampToTime(item.msgtime)
                      }}</i>
                    </b>
                    <div style="margin-top: 10px">
                      <div v-if="item.msgtype === 'image'">
                        <img
                          v-if="item.mediaStatus == 3"
                          :src="baseurl + item.sdkfileid"
                          style="width: 200px; height: auto; border-radius: 0"
                        />
                        <span v-else>[图片]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'voice'">
                        {{ item.mediaStatus }}
                        <audio v-if="item.mediaStatus == 3" controls>
                          <source
                            :src="baseurl + item.sdkfileid"
                            type="audio/ogg"
                          />
                          Your browser does not support the audio element.
                        </audio>
                        <span v-else>[语音]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'file'">
                        <a
                          v-if="item.mediaStatus == 3"
                          :href="baseurl + item.sdkfileid"
                        >
                          {{ item.filename }}
                        </a>
                        <span v-else>[文件]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'emotion'">
                        <image
                          v-if="item.mediaStatus == 3"
                          :src="baseurl + item.sdkfileid"
                        >
                          {{ item.filename }}
                        </image>
                        <span v-else>[表情]</span>
                      </div>

                      <div v-else-if="item.msgtype === 'weapp'">
                        <span>[小程序]</span>
                      </div>

                      <div v-else-if="item.msgtype === 'link'">
                        <span>[链接]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'video'">
                        <video controls="controls" width="60%">
                          <source
                            :src="baseurl + item.sdkfileid"
                            type="video/mp4"
                          />
                          您的浏览器不支持 video 标签。
                        </video>
                      </div>
                      <div
                        v-else
                        @click="scoreView(item.content, index)"
                        v-html="item.content || '未识别'"
                        class="chatTxt"
                      ></div>
                    </div>
                  </div>
                </div>
                <div
                  class="contentItem flex-end"
                  v-if="item.name == searchObj.sendUser"
                >
                  <div class="content" style="text-align: right">
                    <b>
                      <i style="font-size: 12px; font-style: normal">{{
                        timestampToTime(item.msgtime)
                      }}</i>
                      {{ item.name }}
                    </b>
                    <div style="margin-top: 10px; text-align: right">
                      <div v-if="item.msgtype === 'image'">
                        <img
                          v-if="item.mediaStatus == 3"
                          :src="baseurl + item.sdkfileid"
                          style="width: 200px; height: auto; border-radius: 0"
                        />
                        <span v-else>[图片]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'voice'">
                        {{ item.mediaStatus }}
                        <audio v-if="item.mediaStatus == 3" controls>
                          <source
                            :src="baseurl + item.sdkfileid"
                            type="audio/ogg"
                          />
                          Your browser does not support the audio element.
                        </audio>
                        <span v-else>[语音]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'file'">
                        <a
                          v-if="item.mediaStatus == 3"
                          :href="baseurl + item.sdkfileid"
                        >
                          {{ item.filename }}
                        </a>
                        <span v-else>[文件]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'emotion'">
                        <image
                          v-if="item.mediaStatus == 3"
                          :src="baseurl + item.sdkfileid"
                        >
                          {{ item.filename }}
                        </image>
                        <span v-else>[表情]</span>
                      </div>

                      <div v-else-if="item.msgtype === 'weapp'">
                        <span>[小程序]</span>
                      </div>

                      <div v-else-if="item.msgtype === 'link'">
                        <span>[链接]</span>
                      </div>
                      <div v-else-if="item.msgtype === 'video'">
                        <video controls="controls" width="60%">
                          <source
                            :src="baseurl + item.sdkfileid"
                            type="video/mp4"
                          />
                          您的浏览器不支持 video 标签。
                        </video>
                      </div>
                      <div
                        v-else
                        @click="scoreView(item.content, index)"
                        v-html="item.content || '未识别'"
                        class="chatTxt"
                      ></div>
                    </div>
                  </div>
                  <div>
                    <img
                      v-if="item.headUrl"
                      :src="item.headUrl"
                      alt=""
                      class="touxiang marginLeft"
                    />
                    <img
                      v-else
                      src="../image/user.jpg"
                      alt=""
                      class="touxiang marginLeft"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              class="chatRoomContent"
              v-if="!chatContentData || chatContentData.length == 0"
            >
              <a-empty style="margin-top: 100px" />
            </div>
          </div>
        </div>
        <div class="drawerContainer" v-if="visible">
          <a-form
            layout="inline"
            @keyup.enter.native="searchChat"
            style="width: 100%; border-bottom: 1px solid #e5e5e5; padding: 20px"
          >
            <a-row :gutter="24">
              <a-col :md="12" :sm="8">
                <a-form-item label="关键字">
                  <a-input
                    placeholder="请输入关键字"
                    v-model="chatSearchInfo.keyWords"
                  ></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="12" :sm="8">
                <a-form-item label="会话日期">
                  <a-range-picker
                    @change="
                      (data, dateValue) => onDateChange(data, dateValue, '2')
                    "
                    v-model="dateRange"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24" style="margin-top: 10px">
              <a-col :md="24" :sm="24">
                <a-button
                  type="primary"
                  style="margin-right: 10px"
                  @click="searchChat"
                >
                  查询
                </a-button>
                <a-button @click="messageReset('message')"> 重置 </a-button>
              </a-col>
            </a-row>
          </a-form>
          <div class="drawerChatTabs">
            <a-tabs
              default-active-key="1"
              @change="tabChange"
              v-model="activeKey"
            >
              <a-tab-pane key="1" tab="全部">
                <div
                  class="chatContentList"
                  @scroll="upMessageScrollFn"
                  id="message"
                  style="height: 100%"
                >
                  <div
                    class="chatRoomContent"
                    style="height: 100%"
                    v-if="chatInfo && chatInfo.length > 0"
                  >
                    <div v-for="(item, index) in chatInfo" :key="index">
                      <div class="contentItem" @click="goSearch(item.msgid)">
                        <div>
                          <img
                            v-if="item.headUrl"
                            :src="item.headUrl"
                            alt=""
                            class="drawerTouxiang"
                          />
                          <img
                            v-else
                            src="../image/user.jpg"
                            alt=""
                            class="drawerTouxiang"
                          />
                        </div>
                        <div class="content">
                          <b
                            >{{ item.name }}
                            <i style="font-size: 12px; font-style: normal">{{
                              timestampToTime(item.msgtime)
                            }}</i>
                          </b>
                          <div style="margin-top: 10px">
                            <div v-if="item.msgtype == 'image'">
                              <img
                                v-if="item.mediaStatus == 3"
                                :src="baseurl + item.sdkfileid"
                                style="
                                  width: 200px;
                                  height: auto;
                                  border-radius: 0;
                                "
                              />
                              <span v-else>[图片]</span>
                            </div>
                            <div v-else-if="item.msgtype == 'voice'">
                              {{ item.mediaStatus }}
                              <audio v-if="item.mediaStatus == 3" controls>
                                <source
                                  :src="baseurl + item.sdkfileid"
                                  type="audio/ogg"
                                />
                                Your browser does not support the audio element.
                              </audio>
                              <span v-else>[语音]</span>
                            </div>
                            <div v-else-if="item.msgtype == 'file'">
                              <a
                                v-if="item.mediaStatus == 3"
                                :href="baseurl + item.sdkfileid"
                              >
                                {{ item.filename }}
                              </a>
                              <span v-else>[文件]</span>
                            </div>
                            <div v-else-if="item.msgtype == 'emotion'">
                              <image
                                v-if="item.mediaStatus == 3"
                                :src="baseurl + item.sdkfileid"
                              >
                                {{ item.filename }}
                              </image>
                              <span v-else>[表情]</span>
                            </div>

                            <div v-else-if="item.msgtype == 'weapp'">
                              <span>[小程序]</span>
                            </div>

                            <div v-else-if="item.msgtype == 'link'">
                              <span>[链接]</span>
                            </div>
                            <div v-else-if="item.msgtype == 'video'">
                              <video controls="controls" width="60%">
                                <source
                                  :src="baseurl + item.sdkfileid"
                                  type="video/mp4"
                                />
                                您的浏览器不支持 video 标签。
                              </video>
                            </div>
                            <div
                              v-else
                              @click="scoreView(item.content, index)"
                              v-html="item.content || '未识别'"
                              class="chatTxt drawerTxt"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="chatRoomContent"
                    v-if="!chatInfo || chatInfo.length == 0"
                  >
                    <a-empty style="margin-top: 100px" />
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="2" tab="文件" force-render>
                <div class="chatContentList" style="height: 100%">
                  <div
                    class="chatRoomContent"
                    style="height: 100%"
                    v-if="fileData && fileData.length > 0"
                  >
                    <div v-for="(item, index) in fileData" :key="index">
                      <div class="contentItem">
                        <div>
                          <img
                            v-if="item.headUrl"
                            :src="item.headUrl"
                            alt=""
                            class="drawerTouxiang"
                          />
                          <img
                            v-else
                            src="../image/user.jpg"
                            alt=""
                            class="drawerTouxiang"
                          />
                        </div>
                        <div class="content">
                          <b
                            >{{ item.name }}
                            <i style="font-size: 12px; font-style: normal">{{
                              timestampToTime(item.msgtime)
                            }}</i>
                          </b>
                          <div style="margin-top: 10px">
                            <a :href="baseurl + item.sdkfileid">
                              {{ item.filename }}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="chatRoomContent"
                    v-if="!fileData || fileData.length == 0"
                  >
                    <a-empty style="margin-top: 100px" />
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="3" tab="图片与视频">
                <div class="chatContentList" style="height: 100%">
                  <div
                    class="chatRoomContent"
                    style="height: 100%"
                    v-if="imgData && imgData.length > 0"
                  >
                    <div v-for="(item, index) in imgData" :key="index">
                      <div class="contentItem">
                        <div>
                          <img
                            v-if="item.headUrl"
                            :src="item.headUrl"
                            alt=""
                            class="drawerTouxiang"
                          />
                          <img
                            v-else
                            src="../image/user.jpg"
                            alt=""
                            class="drawerTouxiang"
                          />
                        </div>
                        <div class="content">
                          <b
                            >{{ item.name }}
                            <i style="font-size: 12px; font-style: normal">{{
                              timestampToTime(item.msgtime)
                            }}</i>
                          </b>
                          <div style="margin-top: 10px">
                            <div v-if="item.msgtype === 'video'">
                              <video controls="controls" width="60%">
                                <source
                                  :src="baseurl + item.sdkfileid"
                                  type="video/mp4"
                                />
                                您的浏览器不支持 video 标签。
                              </video>
                            </div>
                            <div v-else>
                              <img
                                :src="baseurl + item.sdkfileid"
                                width="400"
                                alt=""
                                style="
                                  width: 200px;
                                  height: auto;
                                  border-radius: 0;
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="chatRoomContent"
                    v-if="!imgData || imgData.length == 0"
                  >
                    <a-empty style="margin-top: 100px" />
                  </div>
                </div>
              </a-tab-pane>
              <a-tab-pane key="4" tab="链接">
                <div class="chatContentList" style="height: 100%">
                  <div
                    class="chatRoomContent"
                    v-if="urlData && urlData.length > 0"
                  >
                    <div v-for="(item, index) in urlData" :key="index">
                      <div class="contentItem">
                        <div>
                          <img
                            v-if="item.headUrl"
                            :src="item.headUrl"
                            alt=""
                            class="drawerTouxiang"
                          />
                          <img
                            v-else
                            src="../image/user.jpg"
                            alt=""
                            class="drawerTouxiang"
                          />
                        </div>
                        <div class="content">
                          <b
                            >{{ item.name }}
                            <i style="font-size: 12px; font-style: normal">{{
                              timestampToTime(item.msgtime)
                            }}</i>
                          </b>
                          <div style="margin-top: 10px">
                            <p>
                              <a-icon type="link" style="font-size: 20px" />
                              <a
                                :href="item.link_url"
                                target="_blank"
                                style="margin-left: 20px"
                                >{{ item.title }}</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="chatRoomContent"
                    v-if="!urlData || urlData.length == 0"
                  >
                    <a-empty style="margin-top: 100px" />
                  </div>
                </div>
              </a-tab-pane>
            </a-tabs>
          </div>
        </div>
      </a-card>
      <div class="rightBtn" @click="showDrawer">
        <a-icon type="double-right" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getAction, postAction } from '@/api/manage';

export default {
  data() {
    return {
      chatListData: [], //左侧聊天记录列表
      chatContentData: [],
      chatValue: 1,
      baseurl:
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_CHATDATA +
        '/conversation/downloadChatData?sdkfileid=',
      url: {
        score: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/irs/rating',
        roomChatList:
          process.env.VUE_APP_CMS_CHATDATA + '/conversation/getChatList',
        chatData: process.env.VUE_APP_CMS_CHATDATA + '/conversation/chatData',
        queryChatList:
          process.env.VUE_APP_CMS_CHATDATA +
          '/conversation/queryChatListByCondition',
        queryCurrentPageMessagesByMessageId:
          process.env.VUE_APP_CMS_CHATDATA +
          '/conversation/queryCurrentPageMessagesByMessageId',
        queryMember:
          process.env.VUE_APP_CMS_CHATDATA +
          '/conversation/getEnterpriseMemberAndExternalUserIdAndName',
      },
      chatType: 3, // 群聊个人聊天区别  1 个人 2 群聊
      isSearching: false,
      loading: false,
      msgfrom: '选择一个群聊',
      pages: 1,
      pagesRight: 1,
      conversationDate: undefined,
      searchObj: {
        sendId: undefined,
        sendUser: undefined,
        receiveId: undefined,
        receiveUser: undefined,
        content: '',
        roomName: '',
        groupMemberName: '',
        conversationTime: '',
        type: undefined,
      },
      dateRange: undefined,
      chatSearchInfo: {
        keyWords: '',
        dateRangeTime: '',
      },
      pageMax: null,
      showMore: false,
      visible: false, //右侧筛选
      activeKey: '1', //tab值
      fileData: [], //文件tab data
      imgData: [], //图片tab data
      urlData: [], //链接tab data
      selectItem: {},
      chatInfo: [], //右侧数据列表
      roomId: '', //聊天记录id
      isActive: -1, //左侧选中的下标
      memberData: [], //用户数据
      userReceiveData: [], //接收人
      userSendData: [], //发送人
      selectData: {
        option1: [
          {
            key: 1,
            value: 1,
          },
          {
            key: 2,
            value: 2,
          },
        ],
        option2: [
          {
            key: 3,
            value: 4,
          },
          {
            key: 4,
            value: 4,
          },
        ],
      },
    };
  },
  created() {
    this.initUserData();
  },
  mounted() {
    // 微信客户跳转搜索聊天
    if (this.$route.query.sendId) {
      this.searchChatFromWx();
    } else {
      this.getChatRoomList();
    }
  },
  methods: {
    //初始化用户数据
    initUserData() {
      let param = {};
      getAction(this.url.queryMember, param).then((res) => {
        if (res.code == 0 && res.result) {
          this.memberData = res.result;
        } else {
          this.memberData = [];
        }
      });
    },
    // 时间戳转换格式
    timestampToTime(timestamp) {
      let date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let year = date.getFullYear() + '-';
      let month =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-';
      let day =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      let hours =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      let minute =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
      let second =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return year + month + day + hours + minute + second;
    },
    // 展开搜索条件
    showMoreSearch() {
      this.showMore = !this.showMore;
    },
    //显示右边
    showDrawer() {
      this.visible = !this.visible;
      this.chatInfo = this.chatContentData;
      this.pagesRight = this.pages;
      this.$nextTick(() => {
        let div = document.getElementById('message');
        if (!div) {
          return;
        }
        div.scrollTop = div.scrollHeight;
      });
    },
    //搜索-发送人/接收人搜索
    handleSearch(value, flg) {
      let arr = [];
      this.memberData.forEach((item) => {
        if (item.name && item.name.indexOf(value) > -1) {
          arr.push(item);
        }
      });
      if (flg == 'sendUser') {
        this.userSendData = arr;
      } else {
        this.userReceiveData = arr;
      }
    },
    //搜索-发送人/接收人选择
    handleChange(value, flg) {
      let str = value ? value.split('_')[0] : '';
      if (flg == 'sendUser') {
        this.searchObj.sendId = str;
      } else {
        this.searchObj.receiveId = str;
      }
      this.initUserData();
    },
    //选择一个聊天
    onChange(id, index) {
      this.pages = 1;
      this.activeKey = '1';
      this.isActive = index;
      this.imgData = [];
      this.fileData = [];
      this.urlData = [];
      this.roomId = id;
      this.chatContentData = [];
      this.selectItem = this.chatListData.find(
        (item) => item.id == this.roomId
      );
      this.getChatContentList(this.selectItem, 'chatContent');
    },
    //聊天列表查询
    searchQuery() {
      //搜索条件为空时不调接口
      // let flg = Object.keys(this.searchObj).filter(e=>{
      //   if(this.searchObj[e]&&this.searchObj[e]!=''){
      //     return e;
      //   }
      // })
      // if(flg.length==0){
      //   return;
      // }
      let params = {
        sendId: this.searchObj.sendId,
        receiveId: this.searchObj.receiveId,
        content: this.searchObj.content,
        roomName: this.searchObj.roomName,
        groupMemberName: this.searchObj.groupMemberName,
        conversationTime: this.searchObj.conversationTime,
        type:
          this.searchObj.type == '' || !this.searchObj.type
            ? 0
            : this.searchObj.type,
        pageSize: 1000000,
        pageNo: 1,
      };
      this.isSearching = true;
      getAction(this.url.queryChatList, params).then((res) => {
        this.isSearching = false;
        if (res.success && res.result && res.result.list) {
          this.chatListData = res.result.list;
          //从其他模块跳转进来
          if (this.$route.query.sendId && this.chatListData.length > 0) {
            this.onChange(this.chatListData[0].id, 0);
          }
        } else {
          this.chatListData = [];
          this.$message.error(res.message);
        }
      });
    },
    //重置
    messageReset(flg) {
      if (flg == 'message') {
        this.chatSearchInfo = {
          keyWords: '',
          dateRangeTime: '',
        };
        this.searchChat();
      } else {
        this.searchObj = {
          sendId: '',
          sendUser: '',
          receiveId: '',
          receiveUser: '',
          content: '',
          roomName: '',
          groupMemberName: '',
          conversationTime: '',
        };
        this.searchQuery();
      }
    },
    //获取左侧聊天列表
    getChatRoomList() {
      //获取全部群聊数据
      let params = {
        pageNo: 1,
        pageSize: 10000000,
      };
      this.isSearching = true;
      getAction(this.url.roomChatList, params).then((res) => {
        this.isSearching = false;
        if (res.success && res.result && res.result.list) {
          this.chatListData = res.result.list;
        } else {
          this.chatListData = [];
          this.$message.error(res.message);
        }
      });
    },
    //获取聊天内容列表
    getChatContentList(item, eleId) {
      this.chatType = item.chatType;
      this.msgfrom = item.title || item.roomName || item.ownerName + '的群';
      let params = {
        pageNo: this.pages,
        pageSize: 10,
        chatType: this.chatType,
      };
      if (item.chatType == 2) {
        // 2 群聊 3 全部群聊
        params.roomId = item.roomId;
        this.roomId = item.roomId;
      } else {
        params.userId1 = item.receiveId;
        params.userId2 = item.sendId || this.$route.query.sendId; // 接受人
        this.userId1 = params.userId1;
        this.userId2 = params.userId2;
      }
      this.queryChatContent(params, eleId);
    },
    queryChatContent(params, eleId) {
      getAction(this.url.chatData, params).then((res) => {
        if (res.code == 0) {
          this.chatContentData = res.result.list;
          this.pages = res.result.pages;
          params.pageNo = this.pages;
          this.$nextTick(() => {
            var div = document.getElementById(eleId);
            div.scrollTop = div.scrollHeight;
            console.log('div.scrollTop**********', div.scrollTop);
          });
          if (
            this.chatContentData &&
            this.chatContentData.length == res.result.total
          ) {
            this.loading = false;
            return;
          }
          getAction(this.url.chatData, params).then((res1) => {
            let arr = res1.result.list;
            // if (res1.code == 0) {
            //   arr = arr.concat(this.chatContentData);
            //   this.handleData(arr);
            // }
            if (res1.result.list.length > 10) {
              this.loading = true;
              if (this.pages >= 0) {
                this.pages--;
              }
              let params = {
                pageNo: this.pages,
                pageSize: 10,
                chatType: this.chatType,
              };
              // 1 个人 2 群聊
              if (this.chatType == 1) {
                params.userId1 = this.userId1;
                params.userId2 = this.userId2;
              } else {
                params.roomId = this.roomId;
              }

              if (arr && arr.length == res1.result.total) {
                this.chatContentData = this.chatContentData.concat(arr); //arr.concat(this.chatContentData);
                this.loading = false;
                return;
              }
              getAction(this.url.chatData, params).then((res2) => {
                if (res2.code == 0) {
                  this.chatContentData = this.chatContentData.concat(arr);
                  this.$nextTick(() => {
                    let div = document.getElementById(eleId);
                    div.scrollTop = div.scrollHeight;
                  });
                }
                this.imgData = [];
                this.fileData = [];
                this.fileData = [];
                this.handleData(this.chatContentData);
                this.loading = false;
              });
            } else {
              this.chatContentData = arr;
              this.$nextTick(() => {
                let div = document.getElementById(eleId);
                if (!div) {
                  return;
                }
                div.scrollTop = div.scrollHeight;
              });
            }
          });
        }
        // this.chatInfo = [];
        // this.$nextTick(() => {
        //   this.chatInfo = this.visible ? this.chatContentData : [];
        // });
        if (res.code === 500) {
          this.$notification['error']({
            message: '获取失败',
            description: res.message,
          });
        }
        this.loading = false;
      });
    },
    //滚动加载
    upScrollFn() {
      let chatContent = document.getElementById('chatContent');
      // 获取距离顶部的距离
      let scrollTop = chatContent.scrollTop;
      // 获取可视区的高度
      let windowHeight = chatContent.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = chatContent.scrollHeight;
      if (scrollTop == 0) {
        if (this.pages > 1) {
          this.pages--;
        } else {
          return;
        }
        let params = {
          pageNo: this.pages,
          pageSize: 10,
          chatType: this.chatType,
          msgContent: this.chatSearchInfo.keyWords,
        };
        // 1 个人 2 群聊
        if (this.chatType == 1) {
          params.userId1 = this.userId1;
          params.userId2 = this.userId2;
        } else {
          params.roomId = this.roomId;
        }

        getAction(this.url.chatData, params).then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.chatContentData = res.result.list.concat(this.chatContentData);
            this.handleData(this.chatContentData);
            this.$nextTick(() => {
              let div = document.getElementById('chatContent');
              div.scrollTop = div.clientHeight;
              console.log('div.scrollTop+++++++', div.scrollTop);
            });
          }
        });
      } else if (scrollTop + windowHeight >= scrollHeight && this.pageMax) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
        this.pageMax++;
        let params = {
          pageNo: this.pageMax,
          pageSize: 10,
          chatType: this.chatType,
          msgContent: this.chatSearchInfo.keyWords,
        };
        params.roomId = this.roomId;
        getAction(this.url.chatData, params).then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.chatContentData = this.chatContentData.concat(res.result.list);
            this.handleData(this.chatContentData);
          }
        });
      } else {
        this.loading = false;
      }
    },
    upMessageScrollFn() {
      let message = document.getElementById('message');
      // 获取距离顶部的距离
      let scrollTop = message.scrollTop;
      // 获取可视区的高度
      let windowHeight = message.clientHeight;
      // 获取滚动条的总高度
      let scrollHeight = message.scrollHeight;
      if (scrollTop == 0) {
        if (this.pagesRight > 1) {
          this.pagesRight--;
        } else {
          return;
        }
        let params = {
          pageNo: this.pagesRight,
          pageSize: 10,
          chatType: this.chatType,
          msgContent: this.chatSearchInfo.keyWords,
        };
        // 1 个人 2 群聊
        if (this.chatType == 1) {
          params.userId1 = this.userId1;
          params.userId2 = this.userId2;
        } else {
          params.roomId = this.roomId;
        }
        getAction(this.url.chatData, params).then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.chatInfo = res.result.list.concat(this.chatInfo);
            this.handleData(this.chatInfo);
            this.$nextTick(() => {
              let div = document.getElementById('message');
              div.scrollTop = div.clientHeight;
            });
          }
        });
      } else if (scrollTop + windowHeight >= scrollHeight && this.pageMax) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
        this.pageMax++;
        let params = {
          pageNo: this.pageMax,
          pageSize: 10,
          chatType: this.chatType,
          msgContent: this.chatSearchInfo.keyWords,
        };
        params.roomId = this.roomId;
        getAction(this.url.chatData, params).then((res) => {
          this.loading = false;
          if (res.code === 0) {
            this.chatInfo = this.chatInfo.concat(res.result.list);
            this.handleData(this.chatInfo);
          }
        });
      } else {
        this.loading = false;
      }
    },
    //处理tab类型
    handleData(arr) {
      this.imgData = [];
      this.fileData = [];
      this.fileData = [];
      arr.forEach((item) => {
        switch (item.msgtype) {
          case 'image':
          case 'video':
            this.imgData.push(item);
            break;
          case 'file':
            this.fileData.push(item);
            break;
          case 'link':
            this.urlData.push(item);
            break;
          default:
            break;
        }
      });
    },
    //切换tab
    tabChange(activeKey) {
      this.activeKey = activeKey;
    },
    //会话日期
    onDateChange(date, dateValue, flg) {
      let presentTime = moment(dateValue[1])
        .add(1, 'days')
        .format('YYYY-MM-DD');
      if (flg == '1') {
        this.searchObj.conversationTime =
          dateValue[0] == '' && dateValue[1] == ''
            ? ''
            : dateValue[0] + '_' + presentTime;
      } else {
        this.chatSearchInfo.dateRangeTime =
          dateValue[0] == '' && dateValue[1] == ''
            ? ''
            : dateValue[0] + '_' + presentTime;
      }
    },
    //根据关键字或会话日期查询聊天内容
    searchChat() {
      //搜索条件为空时不调接口
      // if(this.chatSearchInfo.keyWords==''&& !this.chatSearchInfo.dateRangeTime) {
      //   return;
      // }
      this.pagesRight = 1;
      let params = {
        pageNo: this.pagesRight,
        pageSize: 10,
        chatType: this.chatType,
        msgContent: this.chatSearchInfo.keyWords,
        conditionDate: this.chatSearchInfo.dateRangeTime
          ? this.chatSearchInfo.dateRangeTime
          : '',
      };
      if (this.chatType == 2) {
        params.roomId = this.roomId;
      }
      this.imgData = [];
      this.fileData = [];
      this.urlData = [];
      this.chatInfo = [];
      getAction(this.url.chatData, params).then((res) => {
        if (res.code == 0) {
          this.chatInfo = res.result && res.result.list ? res.result.list : [];
          if (this.chatInfo && this.chatInfo.length > 0) {
            this.$nextTick(() => {
              let div = document.getElementById('message');
              if (!div) {
                return;
              }
              div.scrollTop = div.scrollHeight;
            });
            this.handleData(this.chatInfo);
          }
        } else {
          this.imgData = [];
          this.fileData = [];
          this.fileData = [];
        }
      });
    },
    //微信客户查看会话
    searchChatFromWx() {
      let param = {};
      if (this.$route.query.pageForm == 'warning') {
        this.searchObj.content = this.$route.query.content;
        this.showMore = true;
        this.searchQuery();
      } else {
        if (this.$route.query.sendId) {
          param.memberId = this.$route.query.sendId;
          param.externalUserId = this.$route.query.externalId;
        }
        getAction(this.url.queryMember, param).then((res) => {
          if (res.code == 0 && res.result) {
            let data = res.result;
            console.log('data', data);
            let sendUser = data.find((item) => item.flag == 0);
            let receiveUser = data.find((item) => item.flag == 1);
            this.searchObj.sendId = sendUser.id;
            this.searchObj.sendUser = sendUser.name;
            if ((this.$route.query.externalId = '')) {
              this.searchObj.receiveId = receiveUser.id;
              this.searchObj.receiveUser = receiveUser.name;
            }
            this.searchObj.type = this.$route.query.chatTypeFlg;
            this.chatType = this.$route.query.type ? this.$route.query.type : 2;
            this.searchQuery();
          }
        });
      }
    },
    //定位聊天-拿当前信息的上下文
    goSearch(id) {
      this.loading = true;
      this.chatContentData = [];
      getAction(this.url.queryCurrentPageMessagesByMessageId, {
        msgId: id,
      }).then((res) => {
        this.loading = false;
        if (res.code == 0 && res.result.messages) {
          this.chatContentData = res.result.messages.concat(
            this.chatContentData
          );
          this.pages = res.result.currentPage;
          this.pageMax = res.result.currentPage + 1;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.chatRoom {
  width: 100%;
  overflow: hidden;
}
.showMore {
  // margin-bottom:0;
  // text-align:right;
  // color:#1890FF;
  // line-height: 40px;
  // cursor: pointer;
  display: inline-block;
  color: rgb(24, 144, 255);
  margin-left: 20px;
  cursor: pointer;
}
.rightBtn {
  position: absolute;
  right: 0;
  top: 50%;
  width: 24px;
  height: 80px;
  background: #9999;
  line-height: 80px;
  text-align: right;
  color: #fefefe;
  cursor: pointer;
}
.chatContent {
  width: 100%;
  display: flex;
  height: 538px;
  /deep/.ant-card .ant-card-body {
    height: 100%;
    padding: 0;
    width: 100%;
    display: flex;
  }
  .chatLeft {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .searchtop {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 10px;
    }
    .chatListContainer {
      overflow: auto;
      .chatListItem {
        width: 100%;
        display: flex;
        border-bottom: 1px solid #efefef;
        justify-content: center;
        align-items: center;
        padding: 10px;
        .chatRoomImg {
          width: 40px;
          height: 40px;
          margin-top: 6px;
          border-radius: 50%;
        }
        .chatRoomTitle {
          margin-left: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          width: 200px;
        }
      }
      .chatListItemActive {
        background: #dedede;
      }
    }
  }
  .chatRight {
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #e5e5e5;
    flex: 1;
    .chatTitle {
      height: 60px;
      line-height: 60px;
      font-size: 16px;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 10px;
    }
  }
  .chatContentList {
    flex: 1;
    overflow: auto;
    height: 460px;
  }
  .chatContentList::-webkit-scrollbar {
    width: 3px;
    height: 1px;
  }

  .chatRoomContent {
    width: 100%;
    padding: 0 20px;
    .contentItem {
      width: 100%;
      display: flex;
      padding: 20px 0px;
      .touxiang {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
      }
      .chatTxt {
        display: inline-block;
        background: #ccc;
        line-height: 40px;
        font-size: 16px;
        padding: 0 20px;
        max-width: 600px;
        word-wrap: break-word;
        word-break: break-all;
        border-radius: 10px;
        // position: relative;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        color: black;
      }
      .drawerTxt {
        font-size: 14px;
        line-height: 30px;
      }
      .drawerTouxiang {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 10px;
      }
    }
    .flex-end {
      display: flex;
      justify-content: flex-end;
    }
    .marginLeft {
      margin-left: 10px;
    }
  }

  .drawerContainer {
    max-width: 40%;
    height: 100%;
    .ant-form {
      height: 30%;
      /deep/.ant-form-item .ant-form-item-control-wrapper {
        width: 60%;
      }
    }
    .drawerChatTabs {
      height: 70%;
      .ant-tabs {
        height: 100%;
        /deep/.ant-tabs-tabpane::-webkit-scrollbar {
          width: 3px;
          height: 1px;
        }
        /deep/.ant-tabs-content {
          height: 80%;
        }
      }
    }
  }
  .chatListContainer::-webkit-scrollbar {
    width: 3px;
    height: 1px;
  }
  .chatListContainer {
    /deep/.ant-radio-group .ant-radio-wrapper {
      display: block;
      height: 30px;
      line-height: 30px;
    }
  }
}
</style>
